import React, { useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { useDispatch } from "react-redux"
import { pinSwitchPlayers, updateScoreCounter } from "../../../redux/actions/actions"
import { editEvent } from "../../../api/socket/functions"

function ConfirmEditModal({
	toSend,
	dismissModal,
	initialComment,
	initialEvent,
	initialTeam,
}) {
	const dispatch = useDispatch()
	const [data, setData] = useState({ errors: [] })

	const initData = () => {
		const {
			selectedPlayer,
			selectedEvent,
			selectedTeam,
			followupPlayer,
			followupEvent,
			comment,
			time,
			quarter,
			order,
			eventId,
		} = toSend

		const params = { eventKey: selectedEvent.key, eventId }
		if (time || quarter) {
			params.time = time
			params.quarter = quarter
		} else {
			params.order = order
		}

		const errors = []

		const addToParams = (key, value, error) => {
			if (value) {
				params[key] = value
			} else {
				errors.push(`Nedostaje ${error}`)
			}
		}

		addToParams("comment", comment, "komentar")

		if (!selectedEvent.noTeam) {
			addToParams("team", selectedTeam, "Ekipa")

			if (!selectedEvent.noPlayer) {
				params.playerId = selectedPlayer?.playerId
				params.tshirtNumber = selectedPlayer?.tshirtNumber

				if (selectedEvent.followup) {
					if (selectedEvent.followup.type === "event") {
						addToParams("followupEvent", followupEvent, "razlog")
					} else {
						if (selectedEvent.followup.allowIgnore) {
							if (followupPlayer?.playerId) {
								params.player2Id = followupPlayer.playerId
								params.tshirtNumber2 = followupPlayer.tshirtNumber
							}
						} else {
							addToParams(
								"player2Id",
								followupPlayer?.playerId,
								"drugi igrač"
							)
							if (followupPlayer?.playerId)
								params.tshirtNumber2 = followupPlayer.tshirtNumber
						}
					}
				}
			}
		}

		setData({ isOpen: true, params, errors })
	}

	const onDone = () => {
		const { selectedEvent, selectedTeam, selectedPlayer, followupPlayer } =
			toSend

		const params = { ...data.params }

		const homeTeam = JSON.parse(localStorage.getItem("homeTeam")).name

		if (initialEvent.name === selectedEvent.name) {
			if (selectedEvent.increment) {
				if (selectedEvent.increment > 0) {
					const team = homeTeam === selectedTeam ? "homeTeam" : "awayTeam"
					params.score = { team, value: selectedEvent.increment }
				} else {
					const team = homeTeam !== selectedTeam ? "homeTeam" : "awayTeam"
					params.score = { team, value: -selectedEvent.increment }
				}
			}
		} else {
			if (initialEvent.increment) {
				if (initialEvent.increment > 0) {
					const team = homeTeam === initialTeam ? "homeTeam" : "awayTeam"
					dispatch(updateScoreCounter(team, -initialEvent.increment))
				} else {
					const team = homeTeam !== initialTeam ? "homeTeam" : "awayTeam"
					dispatch(updateScoreCounter(team, initialEvent.increment))
				}
			}
			if (selectedEvent.increment) {
				if (selectedEvent.increment > 0) {
					const team = homeTeam === selectedTeam ? "homeTeam" : "awayTeam"
					dispatch(updateScoreCounter(team, selectedEvent.increment))
					params.score = { team, value: selectedEvent.increment }
				} else {
					const team = homeTeam !== selectedTeam ? "homeTeam" : "awayTeam"
					dispatch(updateScoreCounter(team, -selectedEvent.increment))
					params.score = { team, value: -selectedEvent.increment }
				}
			}
		}

		if (selectedEvent.name === "Zamjena") {
			const isAwayTeam =
				selectedTeam === JSON.parse(localStorage.getItem("awayTeam")).name
			dispatch(
				pinSwitchPlayers(
					selectedPlayer.playerId,
					followupPlayer.playerId,
					isAwayTeam
				)
			)
		}

		editEvent(params)
		onDismiss()
		dismissModal()
	}

	const onDismiss = () => {
		setData({ errors: [] })
	}

	return (
		<>
			<Button.Ripple color="primary" onClick={initData}>
				Spremi
			</Button.Ripple>
			<Modal
				isOpen={data.isOpen}
				toggle={onDismiss}
				className="modal-dialog-centered"
			>
				{data.errors.length > 0 ? (
					<>
						<ModalHeader toggle={onDismiss}>
							Probajte ponovno
						</ModalHeader>
						<ModalBody>
							<p>Nemožete spremiti ovakve promjene.</p>
							<p>Popravite iduće stvari:</p>
							<ul>
								{data.errors.map((error, index) => (
									<li key={`error-${index}`}>{error}</li>
								))}
							</ul>
						</ModalBody>
						<ModalFooter>
							<Button.Ripple color="secondary" onClick={onDismiss}>
								Odustani
							</Button.Ripple>
						</ModalFooter>
					</>
				) : (
					<>
						<ModalHeader toggle={onDismiss}>
							Jeste li sigurni
						</ModalHeader>
						<ModalBody>
							<p>Jeste li sigurni da želite promjeniti event iz:</p>
							<p>
								<b>{initialComment}</b>
							</p>
							<p>u:</p>
							<p>
								<b>{toSend.comment}</b>
							</p>
						</ModalBody>
						<ModalFooter>
							<Button.Ripple color="primary" onClick={onDone}>
								Spremi
							</Button.Ripple>
							<Button.Ripple
								color="secondary"
								outline
								onClick={onDismiss}
							>
								Odustani
							</Button.Ripple>
						</ModalFooter>
					</>
				)}
			</Modal>
		</>
	)
}

export default ConfirmEditModal
